<!-- 头部通用组件 -->
<template>
    <div class="c-header">
        <div class="header-bg">
            <div class="header-content">
                <router-link to='/home'>
                    <img src="../assets/img/logo.png" alt="">
                </router-link>
                <div class="user-info">
                    <span>
                        移动二维码
                    </span>
                    <i></i>
                    <span class="user-login" v-if="!IsLogin">
                        <router-link to="/">登录</router-link>
                        |
                        <router-link to="/">注册</router-link>
                    </span>
                    <span class="username" v-else>
                        {{ Userinfo.membername == 'zbq' ? '访客' : Userinfo.membername }}
                        <a href="javascript: void(0);" @click="loginOut">退出</a>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'CHeader',
        components: {

        },
        props: {
            // 小驼峰命名
            demoInfo: {
                type: String,
                default() {
                    return 'header-demo'
                }
            }
        },
        data() {
            return {
                IsLogin: false,
                Userinfo: {}
            }
        },
        computed: {

        },
        watch: {

        },
        created() {

        },
        mounted() {
            this.isLogin();
        },
        destroyed() {

        },
        methods: {
            isLogin() {
                let Authorization = this.getStore("Authorization");
                if (Authorization) {
                    this.IsLogin = true;
                    this.Userinfo = JSON.parse(this.getStore("userInfo"));
                } else {
                    this.$router.push({ path: '/' });
                }
            },
            loginOut() {
                this.setStore('Authorization', '');
                this.setStore('userInfo', '');
                this.$router.push({ path: '/' });
            }
        }
    }
</script>

<style scoped>
    .c-header {
        height: 50px;
        border-bottom: 1px solid #6999df;
    }

    .header-bg {
        width: 100%;
        height: 100%;
        font-size: 14px;
        color: #ffffff;
        background-color: #1867DD;
    }

    .header-content {
        display: flex;
        justify-content: space-between;
        margin: 0 auto;
        padding: 0 12px;
        width: 1200px;
        height: 100%;
    }

    .header-content a {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .user-info {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .user-info a {
        font-size: 14px;
        color: #ffffff;
    }

    .user-info i {
        margin: 0 26px 0 4px;
        width: 14px;
        height: 14px;
        background: url(../assets/img/icon-code.png) 0 0 no-repeat;
    }

    .user-login {
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .user-login a {
        margin: 0 8px;
    }

    .username {
        display: flex;
    }

    .username a {
        margin-left: 16px;
    }
</style>